import "../sass/main.scss";
import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";
import "slick-carousel/slick/slick";
import "jquery/dist/jquery.min.js";
import $ from "jquery";
import ValidationForm from "./components/validation";
import initCookieAlert from "./components/cookies";

document.getElementsByTagName("html")[0].classList.add("js");

$(document).ready(function () {
  const config = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    fade: true,
  };
  $("#eventSlider").slick(config);
  $("#productionSlider").slick(config);
  $("#giftsSlider").slick(config);

  $(".subpage__section-btn-next").on("click", function () {
    stopVideo();
    $(".subpage__slider").slick("slickNext");
  });

  $(".subpage__section-btn-prev").on("click", function () {
    stopVideo();
    $(".subpage__slider").slick("slickPrev");
  });

  function scrolltoSection(elem) {
    $("html, body").animate(
      {
        scrollTop: $(elem).offset().top - 80,
      },
      800
    );
  }

  const elem = window.location.hash;

  $("a[href='#o_nas']").click(function (e) {
    e.preventDefault();
    if ($("body").hasClass("home-page")) {
      scrolltoSection("#aboutUs");
    } else {
      window.location.href = "index.html#o_nas";
    }
  });

  if (elem == "#o_nas") {
    setTimeout(function () {
      scrolltoSection("#aboutUs");
    }, 800);
  }

  $("a[href='#kontakt']").click(function (e) {
    e.preventDefault();
    if ($("body").hasClass("home-page")) {
      scrolltoSection("#contact");
    } else {
      window.location.href = "index.html#kontakt";
    }
  });

  if (elem == "#kontakt") {
    setTimeout(function () {
      scrolltoSection("#contact");
    }, 800);
  }

  function initMobileMenu() {
    const btnMenu = $("#menuBtn");
    const nav = $(".nav-mobile");

    btnMenu.on("click", function () {
      // nav.fadeToggle();
      nav.toggleClass("nav-mobile-active");
      $(this).toggleClass("show");
    });
  }

  initMobileMenu();

  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  const toggleMobileMenu = debounce(function () {
    const mobileActive = $(".nav-mobile");
    if (
      $(".mobile-ham").not(":visible") &&
      mobileActive.hasClass("nav-mobile-active")
    ) {
      mobileActive.removeClass("nav-mobile-active");
      $(".mobile-ham").removeClass("show");
    }
  }, 250);

  window.addEventListener("resize", toggleMobileMenu);

  $(".nav__link").on("click", function (e) {
    const nav = $(".nav");
    if (nav.hasClass("nav-mobile-active")) {
      nav.removeClass("nav-mobile-active");
    }
  });

  if (document.body.classList.contains("home-page")) {
    const validationForm = new ValidationForm(
      document.querySelector("#contactForm")
    );
  }

  if (document.body.classList.contains("gifts") || "production") {
    const btns = $(".video-btn");

    btns.on("click", function (e) {
      e.preventDefault();
      const slide = $(this).parent();
      const video = slide.find(".subpage__slider-slide-video-player");
      video.fadeIn();
      video[0].play();
      slide.addClass("video-active");
    });
  }

  function stopVideo() {
    const videos = document.querySelectorAll(
      ".subpage__slider-slide-video-player"
    );
    const slides = $(".subpage__slider-slide ");

    slides.removeClass("video-active");
    videos.forEach((video) => {
      video.pause();
      video.currentTime = 0;
      $(video).fadeOut();
    });
  }

  if (document.body.classList.contains("production")) {
    setTimeout(() => {
      $(".preloader").fadeOut("slow");
    }, 2000);
  }

  $(".btn-confirm-more").on("click", function () {
    setTimeout(() => {
      const extra = $(this).prev();
      console.log(extra);

      extra.toggleClass("d-inline");
      if (extra.parent(".error-field").hasClass("error")) {
        extra.parent(".error-field").removeClass("error");
      }
      if (extra.hasClass("d-inline")) {
        $(this).text(" [ukryj zgodę]");
      } else {
        $(this).text(" [pokaż zgodę]");
      }
    }, 0);
  });
});

$(window).on("load", function () {
  if (!document.body.classList.contains("production")) {
    $(".preloader").fadeOut("slow");
  }
});
initCookieAlert();
